import { render, staticRenderFns } from "./AssetChangeLogsDetailsView.vue?vue&type=template&id=a91498fe&scoped=true"
import script from "./AssetChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./AssetChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./AssetChangeLogsDetailsView.vue?vue&type=style&index=0&id=a91498fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91498fe",
  null
  
)

export default component.exports